import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Eye } from "lucide-react";
import { api } from "@/lib/api";
import PublicCheckin from "@/pages/PublicCheckin";
import { SummaryView } from "@/pages/PublicCheckinSummary";
import { BigButton, PublicShell } from "@/components/checkins/public/PublicShell";

function PreviewBanner({ onSummary }) {
  return (
    <div className="sticky top-0 z-20 bg-amber-100 border-b border-amber-300 px-4 py-2 text-center text-sm text-amber-900" data-testid="progress-review-preview-banner">
      <Eye className="mr-1.5 inline h-4 w-4" aria-hidden="true" />
      <b>PREVIEW</b> — staff view of what the client sees. Nothing is saved or sent.
      {onSummary && <button type="button" onClick={onSummary} className="ml-3 underline font-semibold" data-testid="preview-back-to-form">Back to questionnaire</button>}
    </div>
  );
}

export default function ProgressReviewPreview() {
  const { vid } = useParams();
  const [preview, setPreview] = useState(null);
  const [showSummary, setShowSummary] = useState(false);
  const [run, setRun] = useState(0);
  const adapter = useMemo(() => ({
    load: () => api.get(`/checkin-preview/${vid}`).then((r) => r.data),
    submit: (answers) => api.post(`/checkin-preview/${vid}/submit`, { answers }).then((r) => { setPreview(r.data); return r.data.result; }),
  }), [vid, run]); // eslint-disable-line react-hooks/exhaustive-deps

  if (showSummary && preview) {
    const back = () => { setShowSummary(false); setPreview(null); setRun((n) => n + 1); };
    return (
      <PublicShell clinic={preview.summary.clinic} testId="preview-summary-page" banner={<PreviewBanner onSummary={back} />}>
        {preview.hold_reasons.length > 0 && (
          <p className="mb-6 rounded-xl border-2 border-amber-400 bg-amber-50 p-4 text-base text-amber-900" data-testid="preview-held-note">
            Staff note: with these answers the summary would be <b>held for staff review</b> before the client sees it
            ({preview.hold_reasons.join("; ")}).
          </p>
        )}
        <SummaryView d={preview.summary} />
      </PublicShell>
    );
  }
  return (
    <PublicCheckin
      key={run}
      adapter={adapter}
      banner={<PreviewBanner />}
      doneExtra={<BigButton className="mt-6 w-full" onClick={() => setShowSummary(true)} data-testid="preview-view-summary-btn">View the summary page</BigButton>}
    />
  );
}
